/**
 * Centralized Test Scenarios Configuration
 * Controls when and how test scenarios are available
 */

/**
 * Determines if test scenarios should be available
 * Uses REACT_APP environment variable since NODE_ENV is controlled by build process
 * @returns {boolean} Whether test scenarios should be enabled
 */
export const isTestScenariosEnabled = () => {
  // Use REACT_APP_ENABLE_TEST_SCENARIOS for explicit control
  // This can be set in .env files and will be available in the browser
  return process.env.REACT_APP_ENABLE_TEST_SCENARIOS === 'true';
};

/**
 * Determines if mock data should be used based on scenario parameter
 * @param {string|null} devScenario - Scenario from URL parameter
 * @returns {boolean} Whether to use mock data
 */
export const shouldUseMockData = (devScenario) => {
  return isTestScenariosEnabled() && !!devScenario;
};

/**
 * Gets the appropriate query parameter for data fetching
 * @param {string|null} devScenario - Scenario from URL parameter
 * @param {string} userEmplid - User's actual emplid
 * @returns {string} The emplid or scenario to use for querying
 */
export const getQueryEmplid = (devScenario, userEmplid) => {
  return shouldUseMockData(devScenario) ? devScenario : userEmplid;
};

/**
 * Security check: ensures test scenarios are not available in production
 * @returns {boolean} Whether the current environment is secure for test scenarios
 */
export const isSecureForTestScenarios = () => {
  // Only allow if explicitly enabled via environment variable
  return process.env.REACT_APP_ENABLE_TEST_SCENARIOS === 'true';
};

export default {
  isTestScenariosEnabled,
  shouldUseMockData,
  getQueryEmplid,
  isSecureForTestScenarios
};